import { OverlayUtil, Vec, clamp, isCursorInViewport } from "@tldraw/editor";
let _arrowPath = null;
function getArrowPath() {
  if (!_arrowPath) {
    _arrowPath = new Path2D("M -2 -5 L 2 0 L -2 5 Z");
  }
  return _arrowPath;
}
class CollaboratorHintOverlayUtil extends OverlayUtil {
  static type = "collaborator_hint";
  options = { zIndex: 900, lineWidth: 3, viewportPadding: 5 };
  isActive() {
    const viewport = this.editor.getViewportPageBounds();
    const zoom = this.editor.getZoomLevel();
    return this.editor.getVisibleCollaboratorsOnCurrentPage().some((presence) => {
      const { cursor } = presence;
      if (!cursor) return false;
      return !isCursorInViewport(cursor, viewport, zoom);
    });
  }
  getOverlays() {
    const overlays = [];
    const viewport = this.editor.getViewportPageBounds();
    const zoom = this.editor.getZoomLevel();
    for (const presence of this.editor.getVisibleCollaboratorsOnCurrentPage()) {
      const { cursor, color, userId } = presence;
      if (!cursor) continue;
      if (isCursorInViewport(cursor, viewport, zoom)) continue;
      const pad = this.options.viewportPadding / zoom;
      const x = clamp(cursor.x, viewport.minX + pad, viewport.maxX - pad);
      const y = clamp(cursor.y, viewport.minY + pad, viewport.maxY - pad);
      const rotation = Vec.Angle(viewport.center, cursor);
      overlays.push({
        id: `collaborator_hint:${userId}`,
        type: "collaborator_hint",
        props: { x, y, rotation, color }
      });
    }
    return overlays;
  }
  render(ctx, overlays) {
    const zoom = this.editor.getZoomLevel();
    const scale = 1 / zoom;
    for (const overlay of overlays) {
      const { x, y, rotation, color } = overlay.props;
      ctx.save();
      ctx.translate(x, y);
      ctx.scale(scale, scale);
      ctx.rotate(rotation);
      const path = getArrowPath();
      ctx.lineWidth = this.options.lineWidth;
      ctx.strokeStyle = "#ffffff";
      ctx.stroke(path);
      ctx.fillStyle = color;
      ctx.fill(path);
      ctx.restore();
    }
  }
}
export {
  CollaboratorHintOverlayUtil
};
//# sourceMappingURL=CollaboratorHintOverlayUtil.mjs.map
